var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blank-page"},[_c('img',{staticClass:"blank-page_img",attrs:{"src":require("./img/blank.png")}}),_vm._v(" "),_c('div',{staticClass:"blank-page_desc"},[_vm._v("内容不存在或已被删除")])])
}]

export { render, staticRenderFns }